import React, { useState, useEffect } from "react";
import {
    Modal,
    Input,
    Button,
    Form,
    Select,
    InputNumber,
    message,
    Radio,
    DatePicker,
} from "antd";
import dayjs from "dayjs";
import {
    useFetchListCase1,
    useFetchListCase2,
    useFetchGetAuditCase,
    useFetchEditAuditCase,
} from "../hooks/useFetch";

const { TextArea } = Input;
const case1Options = [
    { value: "1", label: "Deposit" },
    { value: "2", label: "Withdraw" },
    { value: "3", label: "Etc" },
    { value: "4", label: "Panel" },
];

const EditModal = ({ visible, onClose, record, refetch }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { mutateAsync: listCase1, isLoading: case1Loading } =
        useFetchListCase1();
    const { mutateAsync: listCase2, isLoading: case2Loading } =
        useFetchListCase2();
    const { mutateAsync: getCase, isLoading: caseDataLoading } =
        useFetchGetAuditCase();
    const { mutateAsync: editCase, isLoading: editCaseLoading } =
        useFetchEditAuditCase();

    //   const [radioChoice, setRadioChoice] = useState(null);
    const [case1, setCase1] = useState(null);
    //   const [case2, setCase2] = useState(null);
    //   const [case3, setCase3] = useState(null);
    const [case2Options, setCase2Options] = useState([]);
    const [case3Options, setCase3Options] = useState([]);
    const [radioValue, setRadioValue] = useState(null);
    useEffect(() => {
        if (!record?.id) return;

        const load = async () => {
            const caseRes = await getCase({ id: record.id });
            const data = caseRes?.result;
            if (!data) return;

            // โหลด case2 options
            let case2List = [];
            if (data.case1) {
                const r2 = await listCase1({ case1: data.case1 });
                case2List = r2?.result || [];
                setCase2Options(case2List);
            }

            // โหลด case3 options
            let case3List = [];
            if (data.case2) {
                const r3 = await listCase2({ case2: data.case2 });
                case3List = r3?.result || [];
                setCase3Options(case3List);
            }

            // set form ทั้งหมดทีเดียว
            form.setFieldsValue({
                case1: data.case1,
                case2: data.case2,
                case3: data.case3,
                radioChoice: data.radioChoice || "1",
                amount: data.amount,
                dateDeposit: data.dateDeposit ? dayjs(data.dateDeposit) : null,
                timeDeposit: data.timeDeposit || null,
            });

            //Set use state value
            setRadioValue(data.radioChoice || "1");
        };

        load();
    }, [visible, record]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const payload = {
                id: record?.id,
                inputId: record?.inputId,
                case1: values.case1,
                case2: values.case2,
                case3: values.case3,
                radioChoice: values.radioChoice,
                amount: values.amount,
                timeDeposit: values.timeDeposit || null,
                dateDeposit: values.dateDeposit?.format("YYYY-MM-DD") || null,
            }
            await editCase(payload);
            message.success("บันทึกข้อมูลสำเร็จ");
            onClose();
            form.resetFields();
            refetch();
        } catch (error) {
            console.error("Validation failed:", error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    const handleCase1Change = async (value) => {
        form.setFieldsValue({ case2: null, case3: null });
        setCase2Options([]);
        setCase3Options([]);
        const case2List = await listCase1({ case1: value });
        if (case2List && case2List?.result) {
            setCase2Options(case2List?.result);
        }
    };
    const handleCase2Change = async (value) => {
        form.setFieldsValue({ case3: null });
        setCase3Options([]);
        const case3List = await listCase2({ case2: value });
        if (case3List && case3List?.result) {
            setCase3Options(case3List?.result);
        }
    };
    const handleCase3Change = async (value) => { };
    const handleRadioChange = (e) => {
        setRadioValue(e.target.value);
        // form.setFieldValue('radioChoice', e.target.value);
    };

    return (
        <Modal
            title="แก้ไขข้อมูล"
            open={visible}
            onCancel={handleCancel}
            loading={caseDataLoading}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    ยกเลิก
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleSubmit}
                >
                    บันทึก
                </Button>,
            ]}
            width={600}
        >
            <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
                <Form.Item
                    name="case1"
                    label="Case1"
                    rules={[{ required: true, message: "Please select case1!" }]}
                >
                    <Select onChange={handleCase1Change} options={case1Options}>
                        <Select.Option value="1">Deposit</Select.Option>
                        <Select.Option value="2">Withdraw</Select.Option>
                        <Select.Option value="3">Etc</Select.Option>
                        <Select.Option value="4">Panel</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="case2"
                    label="Case2"
                    rules={[{ required: true, message: "Please select case2!" }]}
                    disabled={case1Loading}
                >
                    <Select onChange={handleCase2Change} disabled={case1Loading}>
                        {case2Options.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                                {item.casename}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="case3"
                    label="Case3"
                    rules={[{ required: true, message: "Please select case3!" }]}
                >
                    <Select onChange={handleCase3Change} disabled={case2Loading}>
                        {case3Options.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                                {item.casename}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="radioChoice" initialValue={"1"}>
                    <Radio.Group onChange={handleRadioChange}>
                        <Radio value="1">เติม</Radio>
                        <Radio value="2">ไม่เติม</Radio>
                    </Radio.Group>
                </Form.Item>
                {radioValue === "1" && (
                    <>
                        <div
                            className="col-span-2"
                            style={{ display: "flex", alignItems: "center", gap: "8px" }}
                        >
                            <Form.Item
                                name="amount"
                                label="Amount"
                                style={{ marginBottom: 16 }}
                                className="numeric-input"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter the amount!",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Enter amount"
                                    style={{ width: "200px" }}
                                    type="text"
                                    inputMode="decimal"
                                    pattern="^[0-9]*\.?[0-9]*$"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="timeDeposit"
                                //   onChange={(e) => {
                                //     setRemarkText(generateRemarkText());
                                //   }}
                                style={{ marginBottom: 16 }}
                                label="Time (สลิป)"
                                rules={[
                                    {
                                        pattern: /^([0-1]?[0-9]|2[0-3])\.[0-5][0-9]$/,
                                        message: "กรุณากรอกเวลาในรูปแบบ 00.00 ",
                                        required: case1 == 1 || case1 == 2 ? true : false,
                                    },
                                ]}
                            >
                                <Input placeholder="กรอกเวลา(00.00)" maxLength={5} />
                            </Form.Item>
                        </div>
                        <Form.Item
                            name="dateDeposit"
                            style={{
                                marginBottom: 16,
                                color: "red", // สีแดง
                            }}
                            label={
                                <span>
                                    เลือกวันที่ &nbsp;
                                    <span style={{ color: "red" }}>(กรณีเติมย้อนหลัง)</span>
                                </span>
                            }
                        >
                            <DatePicker
                                placeholder="เลือกวันที่"
                                style={{ width: "100%" }}
                                format="DD/MM/YYYY"
                            //   onChange={(date) => {
                            //     setRemarkText(generateRemarkText());
                            //   }}
                            />
                        </Form.Item>
                    </>
                )}
            </Form>
        </Modal>
    );
};

export default EditModal;
